import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = { class: "dataTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('devis.request.title')) + " ", 1),
        _createVNode(_component_ReglePastille, { cle: "demandeDevis.definition" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Filter, {
          onSearch: _ctx.doFilter,
          onSetDemandeDevisId: this.setDemandeDevisId,
          onSetIsMine: this.setIsMine,
          onClearFilter: this.clearFilter,
          onStatusToggleSelectAll: this.statusToggleSelectAll,
          onRemoveFilterStatus: _ctx.removeFilterStatus,
          onAddFilterStatus: this.addFilterStatus,
          filter: this.filter,
          "status-list": _ctx.statusList
        }, null, 8, ["onSearch", "onSetDemandeDevisId", "onSetIsMine", "onClearFilter", "onStatusToggleSelectAll", "onRemoveFilterStatus", "onAddFilterStatus", "filter", "status-list"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(this.count) + " " + _toDisplayString(_ctx.getTitreTableau) + " ", 1),
            _createVNode(_component_ReglePastille, { cle: "suiviDemandeDevis.portee" })
          ]),
          (!_ctx.isExportDisabled)
            ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                key: 0,
                onClick: _ctx.exportXls,
                imgUrl: _ctx.iconeXls,
                title: _ctx.$t('list.export')
              }, null, 8, ["onClick", "imgUrl", "title"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.tableData.length === 0 && _ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, {
              key: 0,
              class: "loader"
            }))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              ref: "content",
              onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
              class: "datatable-container"
            }, [
              _createVNode(_component_DataTable, {
                isLoading: _ctx.isLoading,
                count: +_ctx.count,
                tableData: this.tableData,
                tableHeader: this.tableHeader,
                onSort: _ctx.doSort,
                onSelect: _ctx.goToPage
              }, null, 8, ["isLoading", "count", "tableData", "tableHeader", "onSort", "onSelect"])
            ], 544))
      ])
    ]),
    (_ctx.isExportXlsLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}